// for phaser typings bug
// tslint:disable-next-line no-reference
///<reference path="../node_modules/phaser/typescript/phaser.comments.d.ts" />
///<reference path="../node_modules/@types/node/index.d.ts" />

import * as qs from 'querystring';
import * as domready from 'domready';
import * as fastclick from 'fastclick';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { navigateAction } from 'fluxible-router';

import './app/utils/Polyfill';
import App from './app/index';
import { getMetrics } from './app/components/App';
import Events from './app/utils/Events';
import Context from './app/utils/Context';
// import GameClass from './game';

if (process.env.NODE_ENV === 'production') {
  window.onerror = (message, url, line) => {
    const query = qs.encode({ url, message, line, location: location.href, service: 'comicstore.pixiv.net' });
    Object.assign(new Image(), { src: `https://www.pixiv.net/rpc/js_error.php?${query}` });
  };
}

App.rehydrate({}, (err, context) => {
  Context.context = Object.assign(context, { insertCss: (css) => css._insertCss() });
  context.executeAction(navigateAction, { url: location.pathname }, () => {
    if (process.env.NODE_ENV !== 'production') {
      module.hot && module.hot.accept();
      if (location.search.match('nomenu')) {
        let { width, height } = getMetrics();
        let parent = document.querySelector('#app');
        new GameClass({ parent, width, height });
        return setTimeout(() => {
          Events.dispatch(window, 'app:initialized');
          Events.dispatch(window, 'game:start');
          let el = document.querySelector('#loader');
          el.parentNode.removeChild(el);
        }, 2000);
      }
    }

    ReactDOM.render(React.createElement(context.getComponent(), {
      context: Object.assign(context.getComponentContext(), { insertCss: (css) => css._insertCss() }),
      // GameClass,
    }), document.getElementById('app'), () => fastclick.attach(document.body));
  });
});

domready(() => {
  // loader
  if (document.querySelector('#loader')) {
    let d = new Date('2017/01/08 20:00:00') - Date.now();
    let s = d / 1000;
    let h = ('00' + Math.floor(s / 3600)).slice(-2);
    let m = ('00' + Math.floor((s - (h * 3600)) / 60)).slice(-2);
    let x = 0;

    let pos = [
      '-8px -14px',
      '-60px -14px',
      '-112px -14px',
      '-60px -14px',
    ];
    let txt = d > 0 ? [
      'Loading   \nのこり ' + h + '時間 ' + m + '分',
      'Loading.  \nのこり ' + h + '時間 ' + m + '分',
      'Loading.. \nのこり ' + h + '時間 ' + m + '分',
      'Loading...\nのこり ' + h + '時間 ' + m + '分',
    ] : [
      'Loading   \n',
      'Loading.  \n',
      'Loading.. \n',
      'Loading...\n',
    ];
    let walk = document.querySelector('#loader .walk');
    walk.style.backgroundPosition = pos[3];
    walk.style.backgroundImage = 'url("/images/spritesheet-comicstaff-2.png?20170108")';
    let text = document.querySelector('#loader .text');
    text.textContent = txt[3];
    let intv = setInterval(() => {
      walk.style.backgroundPosition = pos[x];
      text.textContent = txt[x];
      x += 1;
      if (x > 3) {
        x = 0;
      }
    }, 240);
    // try {
    //   localStorage.setItem('app:null', '1');
    // } catch (error) {
    //   clearInterval(intv);
    //   let desc = document.querySelector('#loader .desc');
    //   desc.textContent = 'Not Compatible';
    //   walk.style.backgroundImage = 'url("/images/spritesheet-comicstaff-2.png?20170108")';
    //   text.textContent = 'プライベートブラウズをやめるか\n対応しているブラウザをご利用ください';
    // }

    window.addEventListener('app:initialized', () => {
      clearInterval(intv);
    });
  }

  // TODO proper debugging UI in DOM that is not inserted by JS like below
  // if (process.env.NODE_ENV !== 'production') {
  //   let resetMode = location.search.match('reset');
  //   if (resetMode) {
  //     if (window.confirm('アカウントをリセットします')) {
  //       setTimeout(() => {
  //         let socket = new Socket();
  //         socket.request('delete_profile', {}, () => {
  //           for (let i = localStorage.length; i >= 0; i--) {
  //             localStorage.removeItem(localStorage.key(i));
  //           }
  //           location.href = '/';
  //         });
  //       }, 1000);
  //     }
  //   }
  //
  //   let debugMode = location.search.match('debug');
  //   if (debugMode) {
  //     let debugBoxStyle = document.createElement('style');
  //     debugBoxStyle.type = 'text/css';
  //     debugBoxStyle.innerHTML = '#debugBox {z-index:1000;transform: scaleY(0.5) scaleX(0.1);}#debugBox:hover {transform: none;}';
  //     let debugBox = document.createElement('div');
  //     debugBox.id = 'debugBox';
  //     debugBox.style.position = 'absolute';
  //     debugBox.style.bottom = '0';
  //     debugBox.style.right = '0';
  //     debugBox.style.padding = '10px';
  //     debugBox.style.transition = 'transform 0.3s ease-in-out';
  //     debugBox.style.transformOrigin = 'bottom right';
  //     debugBox.style.background = 'rgba(255,255,255,0.75)';
  //     document.body.appendChild(debugBoxStyle);
  //     document.body.appendChild(debugBox);
  //
  //     //debugBox.innerHTML += '<label>Tick delay: <input id="debugSpeed" type="range" min="1" value="250" max="5000" style="width:50vw;"></label>';
  //     debugBox.innerHTML += '<br><label>Shop size: <input id="shopSize" type="range" min="7" value="18" max="40" style="width:50vw;"></label>';
  //     debugBox.innerHTML += '<br><label>Auto Customer: <input id="autoCustomerSpeed" type="range" min="0" value="0" max="600" style="width:50vw;"></label>';
  //     debugBox.innerHTML += '<br><label><input id="addCustomer" type="button" value="Add customer"></label>';
  //     debugBox.innerHTML += '<label><input id="toggleEnergyBar" type="button" value="Toggle energy bar"></label>';
  //     debugBox.innerHTML += '<label><input id="deleteAccount" type="button" value="Delete account"></label>';
  //     debugBox.innerHTML += '<div id="gpm">game loading...</div>';
  //
  //     let autoCustomerInterval;
  //
  //     /*
  //     document.getElementById('debugSpeed').onchange = function(){
  //       game.shop.originalTickTime = this.value;
  //       console.log(`setting tick delay to ${this.value}ms`);
  //     };
  //     */
  //     document.getElementById('shopSize').onchange = function(){
  //       game.shop.resizeShop(this.value - game.shop.width);
  //       console.log(`setting shop size to ${this.value}`);
  //     };
  //     document.getElementById('autoCustomerSpeed').onchange = function(){
  //       console.log(`generating ${this.value} customers per minute`);
  //       clearInterval(autoCustomerInterval);
  //       if (parseInt(this.value) === 0) {
  //         return;
  //       }
  //       let delay = 60/this.value;
  //       delay *= 1000;
  //       autoCustomerInterval = setInterval(function(){
  //         game.shop.generateCustomer();
  //       }, delay);
  //     }
  //     document.getElementById('addCustomer').onclick = function(){
  //       game.shop.generateCustomer();
  //     };
  //     document.getElementById('toggleEnergyBar').onclick = function(){
  //       game.shop.toggleShowEnergy();
  //     };
  //     document.getElementById('deleteAccount').onclick = function(){
  //       let socket = new Socket();
  //       socket.emit('delete_profile');
  //       for (let i = 0; i < localStorage.length; i++) {
  //         localStorage.removeItem(localStorage.key(i));
  //       }
  //       location.reload();
  //     };
  //
  //     var gpmDisplay = document.getElementById('gpm');
  //     var initGPM = function(){
  //       var startMoney = game.shop.money;
  //       var startTime = (new Date()).getTime();
  //       setInterval(function(){
  //         var nowMoney = game.shop.money;
  //         var nowTime = (new Date()).getTime();
  //         var moneyDiff = nowMoney - startMoney;
  //         var duration = nowTime - startTime;
  //         var minuteCount = duration / 60000;
  //         var gpm = Math.round(moneyDiff/minuteCount) + '';
  //         gpmDisplay.innerText = gpm + ' gpm';
  //       }, 1000);
  //     };
  //     var loadWait = setInterval(function(){
  //       if ((typeof game !== 'undefined') && game.shop && game.shop.targetMoney == game.shop.money) {
  //         clearInterval(loadWait);
  //         initGPM();
  //         return;
  //       }
  //       gpmDisplay.innerText = 'game loading...';
  //       return;
  //     }, 1000);
  //   }
  // }
});



// WEBPACK FOOTER //
// ./src/client.ts